import { render, staticRenderFns } from "./EditMemberModal.vue?vue&type=template&id=905b2b86"
import script from "./EditMemberModal.vue?vue&type=script&lang=js"
export * from "./EditMemberModal.vue?vue&type=script&lang=js"
import style0 from "./EditMemberModal.vue?vue&type=style&index=0&id=905b2b86&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports